<template>
  <!-- downloadScu Modal -->
  <div
    class="modal fade"
    id="downloadScuModal"
    tabindex="-1"
    aria-labelledby="downloadScuModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadScuModalLabel">
            Download Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          Do you want to download this System Configuration Update(SCU)?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="downloadScu"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from "@/stores/download";
import { ref, watch } from "vue";

const downloadStore = useDownloadStore();
const props = defineProps({
  selectedId: { type: String },
});
const selectedScus: any = ref(props.selectedId);



watch(
  () => props.selectedId,
  (newId) => (selectedScus.value = newId)
);

const downloadScu = async () => {
  await downloadStore.retrieveDownloads(selectedScus.value,"admin");
};
</script>
